import { useGetFitterQuery } from 'feature/user/redux/fitter.api'
import { LoaderInCentalPosition } from 'widget'
import styles from './LkmDocumentsList.module.scss'
import { extractFileInfo } from 'pages/LkmDocumentsPage/helpers/extractFileInfo'
import DescriptionIcon from '@mui/icons-material/Description'
import { Link } from 'react-router-dom'
import { Button } from 'ui'

export function LkmDocumentsList() {
  const { data, isLoading } = useGetFitterQuery()

  if (isLoading && !data) return <LoaderInCentalPosition />

  return (
    <div className={styles.documentsList}>
      {data?.documents.map(({ url }) => {
        const documentInfo = extractFileInfo(url)
        return (
          <Button
            //@ts-ignore
            to={url}
            LinkComponent={Link}
            target={'__blank'}
            className={styles.documentsList__document}
            key={url}
            data-testid={`lkm-document-${documentInfo.fileName}`}
          >
            <div className={styles.documentsList__icon}>
              <DescriptionIcon fontSize='large' color='primary' />
            </div>

            <span className={styles.documentsList__fileName}>
              {documentInfo.fileName}
            </span>
          </Button>
        )
      })}
    </div>
  )
}
